import { render } from "./AppRenameCase.vue?vue&type=template&id=5cd23ab4&scoped=true&ts=true"
import script from "./AppRenameCase.vue?vue&type=script&lang=ts"
export * from "./AppRenameCase.vue?vue&type=script&lang=ts"

import "./AppRenameCase.vue?vue&type=style&index=0&id=5cd23ab4&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cd23ab4"]])

export default __exports__